import { genericFormatAmount, formatNumber } from '@panel/commons/helpers/formatAmount';

// eslint-disable-next-line
function dataTableAdapter(data, type) {
  const { postingStatistics, priceStatistics, bestPostingStatistics } = data;
  const formatDifference = (segmentValue, myPostValue) => {
    const diff = myPostValue - segmentValue;
    const diffPositiva = diff < 0 ? diff * -1 : diff;
    const porcentaje = (diffPositiva * 100) / segmentValue;
    // eslint-disable-next-line no-nested-ternary
    const score = diff > 0 ? 'ALTA' : diff < 0 ? 'BAJA' : 'MEDIA';

    const defaultValue = {
      value: 0,
      score: 'MEDIA'
    };

    if (Number.isNaN(porcentaje)) return defaultValue;

    return {
      // me aseguro que el valor sea positivo
      value: porcentaje.toFixed(0),
      score
    };
  };

  if (postingStatistics) {
    const segmentAverage = {
      price:
        priceStatistics && priceStatistics.segmentAmount
          ? genericFormatAmount(priceStatistics.segmentAmount, priceStatistics.currency)
          : null,
      priceByM2:
        priceStatistics && priceStatistics.m2segmentAmount
          ? genericFormatAmount(priceStatistics.m2segmentAmount, priceStatistics.currency)
          : null,
      listPrints: postingStatistics['segment-impressions'],
      postVisits: postingStatistics['segment-visits'],
      visitsAndPrintsAvg: postingStatistics['segment-impressions-to-visit'],
      interested: postingStatistics['segment-leads'],
      visitsInterestedAvg: postingStatistics['segment-visit-to-leads']
    };

    const bestPrice = bestPostingStatistics && bestPostingStatistics.prices[0];

    const bestPostingData = bestPostingStatistics
      ? {
          price: bestPrice ? genericFormatAmount(bestPrice.amount, bestPrice.currency) : null,
          priceByM2:
            bestPostingStatistics['price-by-m2'] && bestPrice
              ? genericFormatAmount(bestPostingStatistics['price-by-m2'], bestPrice.currency)
              : null,
          listPrints: bestPostingStatistics.impressions,
          postVisits: bestPostingStatistics.visits,
          visitsAndPrintsAvg: bestPostingStatistics['impressions-to-visit'],
          interested: bestPostingStatistics.leads,
          visitsInterestedAvg: bestPostingStatistics['visit-to-leads']
        }
      : {};

    const postingToCompareData = type === 'average' ? segmentAverage : bestPostingData;
    return {
      rows: [
        {
          titleRow: 'price',
          myPost: postingStatistics.prices[0]
            ? genericFormatAmount(postingStatistics.prices[0].amount, postingStatistics.prices[0].currency)
            : null,
          segmentAverage: postingToCompareData.price
        },
        {
          titleRow: 'priceByM2',
          myPost:
            postingStatistics['price-by-m2'] && postingStatistics.prices[0]
              ? genericFormatAmount(postingStatistics['price-by-m2'], postingStatistics.prices[0].currency)
              : null,
          segmentAverage: postingToCompareData.priceByM2
        },
        {
          titleRow: 'listPrints',
          myPost: formatNumber(postingStatistics.impressions),
          segmentAverage: formatNumber(postingToCompareData.listPrints),
          difference: formatDifference(postingToCompareData.listPrints, postingStatistics.impressions)
        },
        {
          titleRow: 'postVisits',
          myPost: formatNumber(postingStatistics.visits),
          segmentAverage: formatNumber(postingToCompareData.postVisits),
          difference: formatDifference(postingToCompareData.postVisits, postingStatistics.visits)
        },
        {
          titleRow: 'visitsAndPrintsAvg',
          myPost: formatNumber(postingStatistics['impressions-to-visit']),
          segmentAverage: formatNumber(postingToCompareData.visitsAndPrintsAvg)
        },
        {
          titleRow: 'interested',
          myPost: formatNumber(postingStatistics.leads),
          segmentAverage: formatNumber(postingToCompareData.interested),
          difference: formatDifference(postingToCompareData.interested, postingStatistics.leads)
        },
        {
          titleRow: 'visitsInterestedAvg',
          myPost: formatNumber(postingStatistics['visit-to-leads']),
          segmentAverage: formatNumber(postingToCompareData.visitsInterestedAvg)
        }
      ],
      headers: ['titleRow', 'segmentAverage', 'myPost', 'difference']
    };
  }
}

export { dataTableAdapter };
